let ExpHelper = function () {

    /*
    Carácter    Unicode    
    “	        \u0022
    ‘	        \u0027
    ©	        \u00A9
    ®	        \u00AE
    €	        \u20AC
    °	        \u00B0
    ²	        \u00B2
    ³	        \u00B3
    µ           \u00B5
    ¼	        \u00BC
    ½	        \u00BD
    ¾	        \u00BE
    π           \u03C0
    */

    /**
    * Convierte un caracter, ejemplos: ó, Ï, ñ
    * @param {any} caracter
    */
    function _convertirCaracter(caracter) {
        let resultado = "";
        switch (caracter) {
            case "a":
                resultado = "\u00E1";
                break;
            case "e":
                resultado = "\u00E9";
                break;
            case "i":
                resultado = "\u00ED";
                break;
            case "o":
                resultado = "\u00F3";
                break;
            case "u":
                resultado = "\u00FA";
                break;
            case "A":
                resultado = "\u00C1";
                break;
            case "E":
                resultado = "\u00C9";
                break;
            case "I":
                resultado = "\u00CD";
                break;
            case "O":
                resultado = "\u00D3";
                break;
            case "U":
                resultado = "\u00DA";
                break;
            case "Ñ":
                resultado = "\u00D1";
                break;
            case "&":
                resultado = "\u0022";
                break;
            case "<":
                resultado = "\u003C";
                break;
            case ">":
                resultado = "\u003E";
                break;
            case "n":
                resultado = "\u00F1";
                break;
            case " ":
                resultado = "\u00A0";
                break;
            default:
        }
        return resultado;
    }

    return {
     
        ConvertirCaracter: function (caracter) {
            return _convertirCaracter(caracter)
        }

    }
}

let expHelper = new ExpHelper();
export default expHelper;